import { render, staticRenderFns } from "./subjectListing.vue?vue&type=template&id=a21c9612&scoped=true&"
import script from "./subjectListing.vue?vue&type=script&lang=js&"
export * from "./subjectListing.vue?vue&type=script&lang=js&"
import style0 from "./subjectListing.vue?vue&type=style&index=0&id=a21c9612&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21c9612",
  null
  
)

export default component.exports